const toNumber = (v: any) => {
    if (v === null || v === undefined || v === '') return 0;
    if (typeof v === 'number') return Number.isFinite(v) ? v : 0;
    const normalized = String(v).replace(',', '.');
    const parsed = parseFloat(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
};

// ---------- ROUND ----------
// Must match exactly the backend calculs.ts round function
const round = (value: any) => {
    let num = toNumber(value);
    if (!Number.isFinite(num)) return 0;
    num = parseFloat(num.toFixed(4)); // Avoid floating point errors

    // For values between 0 and 1, temporarily shift to avoid Math.ceil asymmetry
    const isZero = num.toString()[0] === '0';
    if (isZero) num += 1;
    num = Math.ceil(num * 100) / 100;
    if (isZero) num -= 1;

    return parseFloat(num.toFixed(2));
};

// ---------- IS CUSTOMER HT ----------
export const isCustomerHT = (customer: any): boolean =>
    customer?.isHT === true ||
    customer?.isHT === 'true' ||
    customer?.isHT === 1 ||
    customer?.isHT === '1' ||
    customer?.isHt === true ||
    customer?.isHt === 'true';

// ---------- LINE TOTAL HT ----------
export const getInvoiceLineTotalHT = (items: any[]) => {
    const totalHT = items.reduce((acc: number, item: any) => {
        const price = toNumber(item.price);
        const quantity = toNumber(item.quantity);
        const discountValue = toNumber(item.discountValue);

        let discount = 0;
        if (item.discountType === "percent")
            discount = price * quantity * (discountValue / 100);
        else if (item.discountType === "value")
            discount = discountValue;

        const lineTotal = price * quantity - discount;
        return acc + lineTotal;
    }, 0);

    return round(totalHT);
};

// ---------- TOTAL HT ----------
export const getTotalHT = (items: any) => {
    let totalHT = 0;
    for (const item of items) {
        totalHT += getInvoiceLineTotalHT([item]);
    }
    return round(totalHT);
};

// ---------- TOTAL TTC ----------
// Must match exactly the backend calculs.ts getTotalTTC function (group by VAT rate)
export const getTotalTTC = (
    items: any[],
    options?: {
        isCustomerHT?: boolean;
    },
) => {
    const totalHT = getTotalHT(items);
    if (options?.isCustomerHT) return totalHT;

    const differentVatRates = items.reduce((acc: any, item: any) => {
        if (acc.indexOf(item.vat) === -1) acc.push(item.vat);
        return acc;
    }, []);

    let totalVAT = 0;
    for (const vatRate of differentVatRates) {
        let vat = items.reduce(
            (acc: number, item: any) =>
                acc +
                getInvoiceLineTotalHT([item]) *
                    (item.vat === vatRate ? toNumber(item.vat) / 100 : 0),
            0,
        );
        totalVAT += round(vat);
    }

    return round(totalHT + totalVAT);
};

// ---------- TOTAL MARGIN ----------
export const getTotalMargin = (items: any) => {
    let totalPurchasePrice = items.reduce(
        (acc: number, item: any) =>
            acc + (toNumber(item.totalPurchasePrice) * toNumber(item.quantity) || 0),
        0
    );

    let totalSellPrice = getTotalHT(items);

    const itemWithoutTotalPurchasePrice = items.find(
        (item: any) =>
            (item.totalPurchasePrice === undefined ||
                item.totalPurchasePrice === null) &&
            !item._id?.includes("custom")
    );

    if (itemWithoutTotalPurchasePrice) return 0;
    if (!totalPurchasePrice) return 0;

    return totalSellPrice - totalPurchasePrice;
};

export { round };
